import { render, staticRenderFns } from "./FormCreateRedeem.vue?vue&type=template&id=6f97c3c8&"
import script from "./FormCreateRedeem.vue?vue&type=script&lang=js&"
export * from "./FormCreateRedeem.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateRedeem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports